import ImportContactsOneschemaModal from './ImportContactsOneschemaModal.vue'

export default ImportContactsOneschemaModal
